import { ThemeInterface } from '@westwing/ui-kit/Theme';
import styled, { ThemeProps } from 'styled-components';
import { fromBreakpoint, TABLET } from '../../../mediaqueries';

interface ShopToClubBadgeProps extends ThemeProps<ThemeInterface> {
    background?: string;
    textColor?: string;
    mobileFontSize?: number;
    desktopFontSize?: number;
}

export const ShopToClubBadge = styled.div<ShopToClubBadgeProps>`
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    width: 62px;
    height: 62px;
    border: 2px solid white;
    background: ${(props: ShopToClubBadgeProps) =>
        props.background ? props.background : 'linear-gradient(180deg, #DCB2A1 0%, #D1AD7D 155.56%)'};
    color: ${(props: ShopToClubBadgeProps) => (props.textColor ? props.textColor : props.theme.colors.white)};
    text-align: center;
    right: calc(50% - 32px);
    top: -31px;
    border-radius: 50%;
    padding: 4px;
    font-size: ${(props: ShopToClubBadgeProps) => (props.mobileFontSize ? `${props.mobileFontSize}px` : '20px')};
    z-index: 1;

    ${fromBreakpoint[TABLET]<ShopToClubBadgeProps>`
        width: 74px;
        height: 74px;
        right: calc(50% - 37px);
        top: -41px;
        border: 3px solid white;
        font-size: ${(props: ShopToClubBadgeProps) => (props.desktopFontSize ? `${props.desktopFontSize}px` : '24px')};
    `}
`;
